import React from 'react'
import { motion } from 'framer-motion'
import SafeIcon from '../common/SafeIcon'
import { FiCalendar, FiExternalLink, FiClock, FiVideo } from 'react-icons/fi'
import { trackBookingInteraction } from '../utils'

/**
 * Note: Renamed from CalendlyWidget to handle Google Appointment scheduling.
 * File name kept as CalendlyWidget.jsx to avoid breaking existing file structure references,
 * but internal logic updated to Google Calendar.
 */
const CalendlyWidget = ({ inline = false, className = '' }) => {
  const bookingUrl = 'https://calendar.app.google/NFikLXtgYPtfyWPa8'

  const handleBookingClick = () => {
    trackBookingInteraction('booking_link_clicked')
  }

  if (inline) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className={`bg-white rounded-2xl shadow-sm border border-secondary-100 overflow-hidden ${className}`}
      >
        <div className="p-4 md:p-6 bg-primary-50 border-b border-primary-200">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
              <SafeIcon icon={FiCalendar} className="w-5 h-5 text-primary-600" />
            </div>
            <div>
              <h3 className="font-semibold text-secondary-900">Schedule a Strategy Call</h3>
              <p className="text-sm text-secondary-600">Quick conversation to find clarity</p>
            </div>
          </div>
        </div>
        
        <div className="p-6 md:p-8">
          <div className="space-y-4 mb-6">
            <div className="flex items-center space-x-3 text-secondary-600">
              <SafeIcon icon={FiClock} className="w-4 h-4" />
              <span className="text-sm">25-minute conversation</span>
            </div>
            <div className="flex items-center space-x-3 text-secondary-600">
              <SafeIcon icon={FiVideo} className="w-4 h-4" />
              <span className="text-sm">Google Meet (Link provided in invite)</span>
            </div>
          </div>
          
          <a
            href={bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleBookingClick}
            className="w-full inline-flex items-center justify-center space-x-2 bg-primary-600 text-white px-6 py-4 rounded-xl font-semibold hover:bg-primary-700 transition-all shadow-sm hover:shadow-md"
          >
            <span>Book via Google Calendar</span>
            <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
          </a>
          
          <p className="text-xs text-center text-secondary-400 mt-4">
            Opens in a new tab using Google Appointment Scheduling
          </p>
        </div>
      </motion.div>
    )
  }

  // Button version
  return (
    <a
      href={bookingUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleBookingClick}
      className={`inline-flex items-center space-x-2 bg-primary-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-primary-700 transition-colors ${className}`}
    >
      <SafeIcon icon={FiCalendar} className="w-5 h-5" />
      <span>Schedule a Call</span>
      <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
    </a>
  )
}

export default CalendlyWidget